export enum ServiceType {
    SpeechLanguageTherapy = 1,
    AudiologyServices = 2,
    SignLanguageInterpreter = 3,
    OralTransliterator = 4,
  }